import 'react-data-grid/lib/styles.css';

import Papa from 'papaparse';
import { type FC, useEffect, useState } from 'react';
import ReactDataGrid, { type ColumnOrColumnGroup } from 'react-data-grid';

type Props = {
  fileUrl: string;
  height?: number;
  width?: number;
};

const CsvViewer: FC<Props> = ({ fileUrl, height = 650, width }) => {
  const [rows, setRows] = useState<unknown[]>([]);
  const [columns, setColumns] = useState<ColumnOrColumnGroup<unknown, unknown>[]>([]);

  useEffect(() => {
    Papa.parse(fileUrl, {
      complete: (result) => {
        if (result.data && result.data.length > 0) {
          // Create columns from the first row
          const headers = result.data[0] as string[];
          const cols = headers.map((header) => ({
            key: header,
            name: header,
            resizable: true,
            sortable: true
          }));

          // Create rows from the remaining data
          const dataRows = result.data.slice(1).map((row: unknown) => {
            const rowData: Record<string, unknown> = {};

            headers.forEach((header, index) => {
              rowData[header] = (row as unknown[])[index];
            });

            return rowData;
          });

          setColumns(cols);
          setRows(dataRows);
        }
      },
      download: true
    });
  }, [fileUrl]);

  return (
    <div style={{ height, width }}>
      <ReactDataGrid className="rdg-light" columns={columns} rowHeight={35} rows={rows} />
    </div>
  );
};

export default CsvViewer;
